export const navLinks = [
  { navLinkId: 'Home', scrollToId: 'landingContainer' },
  { navLinkId: 'About', scrollToId: 'aboutContainer' },
  { navLinkId: 'Projects', scrollToId: 'projectsContainer' },
  { navLinkId: 'Contact', scrollToId: 'contactContainer' },
]
